import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MessageModal from '@/components/ui/MessageModal';
import SuspensionAppeal from '@/components/shared/SuspensionAppeal';
import { setSuspensionNotice } from '@/shared/store/slices/appSlice';

/**
 * 帳號停權通知（全域，掛在 App）。
 * axios 攔截器收到 USER_2034 時清空登入狀態並設 app.suspensionNotice = 'account'，
 * 這裡負責顯示通知；可關閉，關閉後清回 null。
 */
function AccountSuspendedModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const suspensionNotice = useSelector((state) => state.app.suspensionNotice);
  const modalRef = useRef(null);

  useEffect(() => {
    if (suspensionNotice === 'account') {
      modalRef.current.show();
    }
  }, [suspensionNotice]);

  return (
    <MessageModal
      ref={modalRef}
      status="error"
      size="md"
      onClose={() => dispatch(setSuspensionNotice(null))}
    >
      <h5 className="mb-2">{t('error_user_2034')}</h5>
      {/* mb-5：與其他 MessageModal 的底部留白一致 */}
      <div className="mb-5">
        <SuspensionAppeal />
      </div>
    </MessageModal>
  );
}

export default AccountSuspendedModal;
